import { useState } from 'react';
import { useRoute } from 'wouter';
import bmzLogo from '@assets/1A96C1D5-9AF8-4F70-A8AB-C6CCBB710C26_1753506945755.png';
import beautyOfTheWeekImage from '@assets/E360E6CF-9133-41C5-B2BB-A417E308F009_1753552251418.png';
import { BeautyOfWeekForm } from '@/components/BeautyOfWeekForm';
import StoryPage from '@/components/StoryPage';
import { Helmet } from 'react-helmet-async';
import terryGeneImage from "@assets/C3BCFB3F-8AA7-4794-B970-B2BFD0FA671B_1753593269196.png";
import sideEffectsImage from "@assets/CCF77726-F59F-4B4E-8751-225DF2D54049_1753593269196.png";
import mediaBiasImage from "@assets/51CCE21C-E9DA-4D89-904A-B2987B5B93A8_1753593269196.png";
import essenceFestImage from "@assets/67B5825B-2A06-4E85-8D38-DEC5C7747B6F_1753593269196.png";
import hairShopImage from "@assets/6C6B0F47-1F08-4213-A965-F652BF9032DE_1753593269196.png";
import hiddenColorsImage from "@assets/A2720F8C-2425-4098-88E5-F828AC414424_1753593269196.png";
import guineaPigImage from '@assets/370AB63A-3EE1-4FB2-825E-02AA02875E79_1756958484951.png';
import cbcReparationsImage from '@assets/C1FDA847-58A4-41E6-BE36-C4032D928BA5_1757026091642.png';
import cbcThumbnailImage from '@assets/762FA130-F32D-438F-B1B5-0939A576850B_1757026386113.png';

// BMZ Custom CSS Styles - TMZ Layout with Black Book Colors
const bmzStyles = `
  .bmz-container {
    font-family: 'Arial', 'Helvetica', sans-serif;
    margin: 0;
    background-color: #000;
    color: #fff;
    min-height: 100vh;
  }

  .bmz-header {
    background-color: #fff;
    color: #000;
    padding: 1rem 0;
    text-align: center;
    border-bottom: 3px solid #228b22;
  }

  .bmz-logo {
    height: 80px;
    width: 100%;
    max-width: 400px;
    object-fit: contain;
  }

  .bmz-main-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }

  .bmz-hero-section {
    margin-bottom: 3rem;
  }

  .bmz-thumbnail-story {
    display: flex;
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    cursor: pointer;
    transition: transform 0.2s ease;
    margin-bottom: 1rem;
  }

  .bmz-thumbnail-story:hover {
    transform: translateY(-2px);
  }

  .bmz-thumbnail-image {
    width: 300px;
    height: 200px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .bmz-thumbnail-content {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .bmz-thumbnail-title {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 0.75rem;
    color: #000;
  }

  .bmz-thumbnail-summary {
    font-size: 1rem;
    color: #666;
    margin-bottom: 1rem;
    line-height: 1.5;
  }

  .bmz-read-more {
    background: none;
    border: none;
    color: #228b22;
    font-weight: bold;
    cursor: pointer;
    text-align: left;
    padding: 0;
    font-size: 1rem;
  }

  .bmz-read-more:hover {
    color: #1a6b1a;
  }

  .bmz-stories-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 2rem;
    margin-bottom: 3rem;
  }

  .bmz-story-card {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  }

  .bmz-story-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 20px rgba(0,0,0,0.3);
  }

  .bmz-story-image {
    width: 100%;
    height: 220px;
    object-fit: contain;
    object-position: center;
    background: #f5f5f5;
    flex-shrink: 0;
  }

  .bmz-story-content {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .bmz-story-title {
    font-size: 1.3rem;
    font-weight: bold;
    color: #000;
    margin-bottom: 1rem;
    line-height: 1.3;
  }

  .bmz-story-summary {
    color: #666;
    line-height: 1.5;
    font-size: 1rem;
  }

  .bmz-beauty-section {
    background: linear-gradient(135deg, #1a1a1a, #333333);
    padding: 3rem;
    border-radius: 16px;
    text-align: center;
    margin-bottom: 2rem;
    color: #fff;
    border: 3px solid #ffd700;
    box-shadow: 0 8px 32px rgba(255, 215, 0, 0.3);
    position: relative;
    overflow: hidden;
  }
  
  .bmz-beauty-section::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255, 215, 0, 0.1) 0%, transparent 70%);
    animation: pulse-glow 3s ease-in-out infinite;
  }
  
  @keyframes pulse-glow {
    0%, 100% { opacity: 0.3; }
    50% { opacity: 0.6; }
  }

  .bmz-beauty-title {
    font-size: 2.5rem;
    font-weight: 900;
    margin-bottom: 1rem;
    text-transform: uppercase;
    color: #ffd700;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
    letter-spacing: 2px;
    position: relative;
    z-index: 2;
  }

  .bmz-beauty-image {
    width: 100%;
    max-width: 350px;
    height: auto;
    border-radius: 20px;
    margin: 1.5rem auto;
    display: block;
    border: 4px solid #ffd700;
    box-shadow: 0 8px 25px rgba(255, 215, 0, 0.3);
    position: relative;
    z-index: 2;
    transition: transform 0.3s ease;
  }
  
  .bmz-beauty-image:hover {
    transform: scale(1.05);
  }

  .bmz-beauty-prompt {
    font-size: 1.3rem;
    margin-bottom: 2rem;
    line-height: 1.6;
    color: #ffffff;
    font-weight: 600;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
    position: relative;
    z-index: 2;
  }

  .bmz-beauty-button {
    background: linear-gradient(45deg, #ffd700, #ffed4e);
    color: #000;
    border: 2px solid #fff;
    padding: 1.25rem 3rem;
    border-radius: 50px;
    font-size: 1.1rem;
    font-weight: 900;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    z-index: 2;
    box-shadow: 0 4px 15px rgba(255, 215, 0, 0.4);
    letter-spacing: 1px;
  }

  .bmz-beauty-button:hover {
    background: linear-gradient(45deg, #ffed4e, #ffd700);
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(255, 215, 0, 0.6);
    border-color: #ffd700;
  }

  .bmz-back-button {
    background: #228b22;
    color: #fff;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    cursor: pointer;
    margin: 1rem;
    font-size: 1rem;
    font-weight: 600;
    transition: background 0.2s ease;
  }

  .bmz-back-button:hover {
    background: #1e7b1e;
  }

  .bmz-article-content {
    background: #fff;
    margin: 1rem;
    padding: 2rem;
    border-radius: 12px;
    max-width: 900px;
    margin: 1rem auto;
    color: #333;
    line-height: 1.7;
  }

  .bmz-article-content h1 {
    color: #228b22;
    font-size: 2.2rem;
    margin-bottom: 1rem;
    font-weight: bold;
    border-bottom: 3px solid #228b22;
    padding-bottom: 0.5rem;
  }

  .bmz-article-content p {
    margin-bottom: 1.2rem;
    font-size: 1.05rem;
  }

  .bmz-article-content img {
    width: 100%;
    height: 350px;
    object-fit: cover;
    border-radius: 8px;
    margin: 1.5rem 0;
  }

  .bmz-article-content em {
    color: #666;
    font-style: italic;
    font-size: 1.1rem;
  }

  .bmz-ad-section {
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    margin: 2rem 0;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    border: 2px solid #228b22;
  }

  .bmz-blackbook-ad {
    background: linear-gradient(135deg, #228b22, #32cd32);
    color: #fff;
  }

  .bmz-subscription-ad {
    background: linear-gradient(135deg, #000, #333);
    color: #fff;
    border: 2px solid #ffd700;
  }

  .bmz-business-ad {
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    color: #000;
  }

  .bmz-ad-content h3 {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .bmz-ad-content p {
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
  }

  .bmz-ad-button {
    background: #fff;
    color: #000;
    border: 2px solid #000;
    padding: 1rem 2rem;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .bmz-blackbook-ad .bmz-ad-button {
    background: #ffd700;
    color: #000;
    border: 2px solid #ffd700;
  }

  .bmz-subscription-ad .bmz-ad-button {
    background: #ffd700;
    color: #000;
    border: 2px solid #ffd700;
  }

  .bmz-ad-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  }

  @media (max-width: 768px) {
    /* Main container mobile fixes */
    .bmz-main-container {
      padding: 0.75rem;
      max-width: 100%;
      margin: 0 auto;
    }
    
    /* Header mobile alignment */
    .bmz-header {
      padding: 1rem;
      text-align: center;
    }
    
    .bmz-logo {
      height: 70px;
      width: 100%;
      max-width: 350px;
      object-fit: contain;
    }
    
    /* Hero section mobile */
    .bmz-hero-section {
      margin-bottom: 1.5rem;
    }
    
    .bmz-thumbnail-story {
      flex-direction: column !important;
      padding: 0 !important;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      background: white;
      margin-bottom: 1rem;
    }
    
    .bmz-hero-section .bmz-thumbnail-image,
    .bmz-thumbnail-image {
      width: 100% !important;
      height: 110px !important;
      max-height: 110px !important;
      min-height: 110px !important;
      object-fit: contain !important;
      object-position: center !important;
      margin-bottom: 0 !important;
      border-radius: 0 !important;
      flex-shrink: 0 !important;
      background: #f5f5f5 !important;
    }
    
    .bmz-thumbnail-content {
      width: 100%;
      padding: 1.25rem !important;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
    
    .bmz-thumbnail-title {
      font-size: 1.25rem;
      line-height: 1.2;
      margin-bottom: 0.75rem;
    }
    
    .bmz-thumbnail-summary {
      font-size: 0.9rem;
      line-height: 1.4;
      margin-bottom: 1rem;
    }
    
    .bmz-read-more {
      font-size: 0.9rem;
    }
    
    /* Beauty section mobile */
    .bmz-beauty-section {
      padding: 2rem 1rem;
      margin-bottom: 1.5rem;
      border-radius: 12px;
    }
    
    .bmz-beauty-title {
      font-size: 1.4rem;
      margin-bottom: 1rem;
    }
    
    .bmz-beauty-image {
      width: 100%;
      max-width: 250px;
      height: auto;
      border-radius: 8px;
      margin-bottom: 1rem;
    }
    
    .bmz-beauty-prompt {
      font-size: 0.9rem;
      line-height: 1.4;
      margin-bottom: 1.5rem;
    }
    
    .bmz-beauty-button {
      padding: 0.75rem 1.5rem;
      font-size: 0.9rem;
    }
    
    /* Stories grid mobile - WHITE CRIMES MATTER style */
    .bmz-stories-grid {
      grid-template-columns: 1fr;
      gap: 1.25rem;
      margin-bottom: 1.5rem;
    }
    
    .bmz-story-card {
      flex-direction: column !important;
      padding: 0 !important;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      background: white;
      margin-bottom: 1rem;
      cursor: pointer;
      transition: transform 0.2s ease;
    }
    
    .bmz-story-card:hover {
      transform: translateY(-2px);
    }
    
    .bmz-stories-grid .bmz-story-image,
    .bmz-story-image {
      width: 100% !important;
      height: 110px !important;
      max-height: 110px !important;
      min-height: 110px !important;
      object-fit: contain !important;
      object-position: center !important;
      margin-bottom: 0 !important;
      border-radius: 0 !important;
      flex-shrink: 0 !important;
      background: #f5f5f5 !important;
    }
    
    .bmz-story-content {
      width: 100%;
      padding: 1.25rem !important;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
    
    .bmz-story-title {
      font-size: 1.25rem;
      line-height: 1.2;
      margin-bottom: 0.75rem;
      color: #000;
      font-weight: bold;
    }
    
    .bmz-story-summary {
      font-size: 0.9rem;
      line-height: 1.4;
      color: #666;
      margin-bottom: 1rem;
    }
    
    /* Ad sections mobile */
    .bmz-ad-section {
      padding: 1.5rem 1rem;
      margin-bottom: 1.5rem;
      border-radius: 8px;
    }
    
    .bmz-ad-content h3 {
      font-size: 1.3rem;
      margin-bottom: 0.75rem;
    }
    
    .bmz-ad-content p {
      font-size: 0.9rem;
      margin-bottom: 1.25rem;
      line-height: 1.4;
    }
    
    .bmz-ad-button {
      padding: 0.75rem 1.5rem;
      font-size: 0.9rem;
      border-radius: 6px;
    }
    
    /* Article content mobile */
    .bmz-article-content {
      padding: 1rem;
      max-width: 100%;
    }
    
    .bmz-article-content h1 {
      font-size: 1.5rem;
      line-height: 1.2;
      margin-bottom: 1rem;
    }
    
    .bmz-article-content p {
      font-size: 0.9rem;
      line-height: 1.5;
      margin-bottom: 1rem;
    }
    
    .bmz-back-button {
      padding: 0.5rem 1rem;
      font-size: 0.9rem;
      margin-bottom: 1rem;
    }
  }
`;

const BMZHomePage = () => {
  const [selectedArticle, setSelectedArticle] = useState<string | null>(null);
  const [showBeautyForm, setShowBeautyForm] = useState(false);

  const articles = [
    {
      id: 'fba-origin-story',
      title: 'A People\'s Origin Story: Were We Already Here?',
      summary: 'An explosive investigation into FBA origins challenges everything you thought you knew about Black American presence in the Americas.',
      thumbnail: '/assets/fba-origin-story-thumbnail.png',
      content: `**By BMZ Staff**

A BMZ staff writer began by asking an AI a simple but explosive question: "Were we already here?" What follows is our best, sourced, good-faith reconstruction—built from archaeology, genetics, early chronicles, and the Black Atlantic record—told with the terms we choose.

Per editorial framing, we use "African" only for deep-time origins; for the rest, we use Indigenous and Foundational Black Americans (FBA). We also credit Dr. Claude Anderson, whose advocacy around lineage-based reparations has shaped this conversation.

⸻

**1. Deep Time: Human Origins**

![Ancient Voyages - Sub-Saharan Africans to the Americas](/assets/ancient-voyages-infographic.png)

• Homo sapiens remains from Morocco (~315k years) and Ethiopia (~233k years) anchor Africa as the origin point.
• Early dispersals: fossils in Arabia (85–120k years), footprints in Saudi Arabia.
• Australia (Sahul) was settled by ~65k years ago.
• Skin color adaptations are recent (genes SLC24A5, SLC45A2).
• **But evidence suggests Equatorial & Southern Africans crossed the South Atlantic 20,000-30,000 years ago, bringing dark-skinned migrants to Georgia, Florida, Tennessee, and Louisiana.**

⸻

**2. First Americans**

![The First Americans - Dating Back 30,000 to 50,000 Years Ago](/assets/first-americans-30k-50k.png)


• **White Sands footprints**: ~21–23k years ago - oldest confirmed human presence in North America.
• **Monte Verde, Chile**: ~14.5k years ago.
• **Population Y signal** in Amazon suggests complex founding diversity.
• **Taíno continuity** in Caribbean.
• **Polynesian–Native American contact** ~1200 CE.

⸻

**3. Afro-Indigenous Presence Before Jamestown**

![Black Indigenous People - Lived in the Southeast for Thousands of Years](/assets/black-indigenous-people.png)

![Explorer Receipts - Negros de la Tierra](/assets/explorer-receipts.png)


• **Estevanico** (Morocco) with Narváez expedition (1528).
• **1526**: San Miguel de Gualdape colony rebellion (Georgia/SC).
• **Garífuna** (Black Caribs) in St. Vincent.
• **De Soto expedition** (1539–42) records include mention of **'negros de la tierra'** (blacks of the land).
• **In their own chronicles, Spanish explorers described meeting dark-skinned natives already rooted in Florida and Georgia.**

⸻

**4. Slave Trade Numbers**

![The Brookes Slave Ship Diagram 1788](https://upload.wikimedia.org/wikipedia/commons/8/82/Slaveshipposter.jpg)

• **12.5 million embarked**, ~10.7 million survived. Only **3–5% landed directly in North America**.
• **Brookes diagram** illustrates regulated capacity (1788).
• **Wrecks**: São José (1794), Clotilda (1860) confirm some voyages.

⸻

**5. Misreads & Reclassification**

![Olmec Colossal Head - Indigenous, Not African](/assets/olmec-colossal-head-hq.png)

• **Olmec heads are Indigenous portraits**, not African imports.
• **Moai are Polynesian**, with evidence of Native contact ~1200 CE.
• **Europeans classified dark-skinned natives as 'negros de la tierra'** but later erased them from the record.

⸻

**6. Names & Nations**

![Settlement Figures - 550,000 Native Black Population in 1500](/assets/settlement-figures.png)

![Bearing on Maps - African Presence Recognized in Early European Maps](/assets/bearing-on-maps.png)

![How They Got Here - Transatlantic Voyages](/assets/transatlantic-voyages.png)


• **550,000 estimated Native Black population in 1500**
• **8 million projection for present-day populations**
• **100,000+ years of occupation**
• **'America'** named on 1507 Waldseemüller map.
• **'United States of America'** formally adopted Sept 9, 1776.
• **We call ourselves Foundational Black Americans (FBA)**, naming on our own terms.

⸻

**7. So—Were We Already Here?**

Evidence points to **both Indigenous Black presence** seen by explorers in the 1500s **and later Afro-Indigenous communities**. 

The math of trans-Atlantic trafficking is documented, but **millions of today's FBA can trace continuity to populations already rooted in the Southeast U.S. before Columbus**.

⸻

**8. The Hard Truth**

This isn't about denying the horror of the slave trade—it's about **reclaiming the full story**. 

The narrative that **all Black Americans descend solely from enslaved Africans** serves to:
• Erase Indigenous Black presence
• Justify land theft 
• Deny deeper claims to this continent

**We were here. We survived. We are still here.**

⸻

**Sources**: Explorer chronicles, archaeological reports, SlaveVoyages database, White Sands National Park research, Library of Congress collections, and modern scholarship.`
    },
    {
      id: 'cbc-japanese-reparations',
      title: 'When the CBC Backed Japanese Reparations But Still Hasn\'t Delivered for Black America',
      summary: 'In 1988, Congress passed reparations for Japanese Americans with CBC support. 35 years later, Black Americans are still waiting.',
      thumbnail: cbcThumbnailImage,
      content: `**By BMZ Staff**

⸻

**A Bill That Changed History—But Not for Us**

![CBC Reparations Timeline](${cbcReparationsImage})

In 1988, Congress passed the Civil Liberties Act, a landmark law that issued a formal apology and $20,000 in reparations to Japanese Americans who were imprisoned in U.S. internment camps during World War II. President Ronald Reagan signed the bill into law, and checks soon followed.

The Congressional Black Caucus (CBC)—the very body meant to champion the cause of Black America—stood firmly behind that legislation. Dozens of CBC members, including figures like John Conyers, Ron Dellums, Louis Stokes, Charles Rangel, and John Lewis, cosponsored the bill and helped usher it into law.

⸻

**Why Reparations for Them First?**

Here's the contradiction that has haunted Black America ever since:
• The Japanese American community had almost no representation in Congress at the time.
• Yet they successfully secured reparations in one generation.
• The CBC, founded in 1971 specifically to give Black Americans a unified voice, helped make it happen.
• But when it comes to reparations for the descendants of enslaved Black Americans—Foundational Black Americans (FBA)—the Caucus has stalled, sidestepped, or outright avoided the fight.

⸻

**What Motivated the CBC's Support?**

The official reasons for supporting H.R. 442 included:
• **Solidarity with another oppressed group** – Many CBC members saw Japanese internment as a clear civil-rights violation that deserved redress.
• **Moral consistency** – Leaders like Conyers and Dellums had long championed human rights and saw this as an extension of that fight.
• **Political momentum** – The internment story was increasingly acknowledged in mainstream media, giving the bill traction.
• **Limited cost** – The government calculated the payments at under $2 billion total, a figure Congress found manageable.

But the deeper issue is this: if they could find the moral courage, political will, and money for another community, why not their own?

⸻

**Sidebar: The Roll Call**

CBC Members Who Cosponsored the Japanese American Reparations Bill (H.R. 442, 100th Congress, 1987–88)
• William (Bill) Clay
• Cardiss Collins
• John Conyers Jr.
• George W. Crockett Jr.
• Ronald V. Dellums
• Julian C. Dixon
• Mervyn M. Dymally
• Mike Espy
• Walter E. Fauntroy (D.C. Delegate)
• Floyd H. Flake
• Harold E. Ford Sr.
• William H. Gray III
• Augustus F. (Gus) Hawkins
• Charles A. Hayes
• George "Mickey" Leland
• John Lewis
• Kweisi Mfume
• Major R. Owens
• Charles B. Rangel
• Gus Savage
• Louis Stokes
• Edolphus Towns
• Alan Wheat

⸻

**The CBC's Track Record on Black Reparations**
• John Conyers introduced H.R. 40, the reparations study bill, in 1989—just one year after helping cosponsor the Japanese reparations bill. It has been reintroduced in every Congress since.
• 35 years later, it still hasn't passed.
• CBC members have rallied around symbolic victories—Juneteenth, the anti-lynching act—but reparations for FBA remain blocked.

⸻

**The Hard Truth**

The uncomfortable reality is that political courage has limits when donors, party leadership, and outside groups set the agenda. Even when Black lawmakers hold office, our issues are bargained away or buried in committees.

The Civil Liberties Act of 1988 proves something powerful: Congress can and will do reparations—when it wants to.

⸻

**Lessons for FBA Communities**
1. **Representation alone is not enough.** Japanese Americans didn't have dozens of lawmakers in Congress; they had focused advocacy, airtight documentation, and relentless organizing.
2. **Coalitions don't guarantee reciprocity.** Black lawmakers stood for Japanese reparations, but the same solidarity has not come back to FBAs.
3. **Moral arguments work only when paired with political pressure.** The Japanese fight combined legal cases, media narratives, and grassroots activism that Congress could not ignore.

⸻

**What Comes Next**

For Foundational Black Americans, the takeaway is simple:
• Stop waiting for the CBC to deliver. Their track record shows they will support others while deferring our cause.
• Build independent FBA political infrastructure—PACs, think tanks, candidate pipelines.
• Demand accountability: either current CBC members push a reparations agenda now, or new FBA-first candidates take their seats.

⸻

**Final Word**

In 1988, Congress showed reparations were not impossible. They showed it could be done quickly, decisively, and with bipartisan support—just not for us.

If they could do it for Japanese Americans with no seats at the table, there is no excuse for why FBA reparations have not been passed with an entire Congressional Black Caucus in the room.`
    },
    {
      id: 'reclassification-network',
      title: 'The Reclassification Network: Paper Genocide in America',
      summary: 'How government officials systematically erased Black and Indigenous identities through bureaucratic warfare, forcing thousands into false racial categories.',
      thumbnail: '/assets/plecker-quote-thumbnail.png',
      content: `**By BMZ Staff**

⸻

**The System That Erased Us**

![Why Were We Reclassified?](/assets/why-reclassified-image.png)

What most Americans don't know is that between 1912 and 1974, a coordinated network of government officials carried out what can only be described as **paper genocide**—the systematic erasure of Black and Indigenous identities through forced reclassification.

This wasn't random bureaucracy. It was a deliberate strategy to destroy lineage, deny land rights, and eliminate inconvenient populations from the official record.

⸻

**Page 1: Virginia & Louisiana – The Architects**

**Walter A. Plecker (1861–1947)**
• Registrar of Virginia's Bureau of Vital Statistics (1912–1946)
• Architect of the 1924 Racial Integrity Act
• Issued 1943 circular and surname list branding Virginia families as 'mongrels'
• **His own words**: *"There does not exist today a descendant... claiming to be an Indian who is unmixed with Negro blood."*

**Naomi Ruth Mason Drake (1892–1970s)**
• Registrar, Bureau of Vital Statistics, New Orleans (1949–1965)
• Enforced binary 'white/colored' system
• **Withheld ~4,700 birth certificates** unless reclassified
• Fired in 1965 for an "unreasonable preoccupation with racial origins"

**John Powell & Earnest Sevier Cox**
• Founders of the Anglo-Saxon Clubs of America (1922)
• Lobbied directly for Virginia's Racial Integrity Act
• Supplied pseudoscientific and cultural justifications for paper genocide

⸻

**Page 2: The Wider Network & Receipts**

![Eugenics Era Legislators](/assets/eugenics-legislators-image.png)

**North Carolina Eugenics Board (1929–1974)**
• Sterilized ~7,600 people, disproportionately Black
• Used state power to police lineage and control populations

**Louisiana's 1/32 Rule & Susie Guillory Phipps (1983)**
• State law defined anyone with ≥1/32 'Negro blood' as Black
• Susie Phipps sued after discovering she was classified 'colored'
• Law repealed in 1983 after national embarrassment

**The Hidden Hands: Clerks, Registrars, Midwives**
• Plecker and Drake depended on thousands of local officials
• Hospitals, clerks, and midwives were ordered to mark doubtful cases as 'colored'
• This distributed bureaucracy turned paper rules into lived reality

⸻

**The Receipts Are Real**

• **Plecker's 1943 circular & surname list** (Library of Virginia)
• **Drake's 1965 hearings** documenting withheld certificates
• **Phipps case (1983)** repealing Louisiana's 1/32 law

⸻

**What They Were Trying to Hide**

The reclassification network wasn't just about racial purity—it was about **land theft and identity destruction**.

By forcing Black and Indigenous families into the "colored" category:
• Tribal land claims were invalidated
• Property rights were stripped away
• Cultural continuity was broken
• Family histories were officially erased

⸻

**The Modern Legacy**

This system didn't end in 1974. Its effects echo today in:
• Families who don't know their true heritage
• Tribes fighting for federal recognition
• Black Americans told they have "no culture"
• Land disputes based on falsified records

⸻

**Fighting Back**

Today's movements for FBA reparations and Indigenous sovereignty directly challenge this legacy of paper genocide. When we demand recognition and restitution, we're not just asking for money—we're demanding the truth that was bureaucratically stolen from us.

**The network that reclassified us can be exposed. The documents exist. The truth is waiting.**

⸻

**Sources**: Library of Virginia Archives, Louisiana State Records, North Carolina Department of Health and Human Services, Federal Court Records (Phipps v. Louisiana), Congressional hearings on eugenics programs.`
    },
    {
      id: 'guinea-pig-experiment',
      title: 'We Will Not Be Your Guinea Pig',
      summary: 'In the 1950s and 60s, St. Louis residents—particularly in Pruitt-Igoe—became unwilling test subjects in secret U.S. Army chemical experiments.',
      thumbnail: guineaPigImage,
      content: `**By BMZ Staff**

In the 1950s and early 1960s, the people of St. Louis—particularly the residents of the now-demolished Pruitt–Igoe housing complex—became unwilling test subjects in a secret U.S. Army experiment. Under the cover of "defense research," the military sprayed zinc cadmium sulfide (ZnCdS), a chemical compound with potential health risks, over neighborhoods that were largely Black and working-class.

Planes, station wagons, and rooftop blowers released this chemical fog, which often looked like smoke or mist to unsuspecting residents. Children played in it. Families breathed it in. And no one was told the truth.

⸻

The Silent Experiment

The operation was part of Operation LAC (Large Area Coverage), a Cold War–era program designed to study how chemical or biological weapons might spread in an urban environment. St. Louis was chosen as a testing ground without its citizens' knowledge or consent.

Government officials later claimed the tests were harmless. But for survivors who lived through it, those words ring hollow. Decades of illness, premature deaths, and broken trust remain as the true legacy of the so-called "safe" experiments.

⸻

The Human Cost

Pruitt–Igoe residents recall the haze, the strange machines, and the unexplained sicknesses that followed. Families lost loved ones young. Cancer rates seemed too high to ignore. The community was left with lingering suspicion that they were never viewed as citizens worthy of protection—but as bodies for experimentation.

Ben Phillips and Chester Deanes, who lived in Pruitt–Igoe as children, are now leading a movement demanding justice. They argue that the studies dismissing health risks were incomplete and biased. They want comprehensive soil testing, medical studies, financial compensation, and—at the very least—a formal apology from the government.

⸻

Justice Delayed, Justice Demanded

Today, Congress is considering legislation that could extend federal compensation programs to Pruitt–Igoe survivors. Advocates are pushing hard for recognition, accountability, and reparations. For many, this fight is about more than money—it's about dignity, truth, and acknowledgment of the harm inflicted.

This case also highlights a broader American pattern: communities of color repeatedly subjected to unethical experiments, from the Tuskegee syphilis study to radiation testing on vulnerable populations.

⸻

We Will Not Be Your Guinea Pig

The story of Pruitt–Igoe is not just history—it is a warning. Governments must never again treat citizens, particularly marginalized communities, as expendable.

"We will not be your guinea pig," say the survivors.
Their message is clear: consent matters, transparency matters, and justice matters.

For St. Louis and for America, reckoning with this past is the only way to build a future rooted in trust and accountability.`
    },
    {
      id: 'terry-gene-racist',
      title: 'Terry Gene Was Racist Face It',
      summary: 'Breaking down the documented history of racist statements that mainstream media refuses to acknowledge.',
      thumbnail: terryGeneImage,
      content: `**By BMZ Staff**

It's time to stop sanitizing history and face the truth about Terry Gene's documented racist statements that have been conveniently ignored by mainstream narratives.

Throughout his career, Gene made numerous inflammatory statements that revealed his true beliefs:

**"They're not like us"** - His repeated use of "they" and "them" when discussing Black communities wasn't accidental. It was deliberate othering designed to create division.

**Economic discrimination** - Gene consistently opposed funding for predominantly Black schools and neighborhoods, calling it "wasteful spending" while supporting identical programs in white areas.

**Dog whistles galore** - His speeches were filled with coded language: "urban problems," "cultural differences," and "traditional values" - all euphemisms for his racist ideology.

**Opposition to civil rights** - Gene actively campaigned against voting rights expansion, fair housing laws, and equal employment opportunities, always framing it as "government overreach."

**The welfare queen myth** - He popularized harmful stereotypes about Black mothers, using isolated cases to paint entire communities as lazy and dependent.

**Crime rhetoric** - Constantly associated Black communities with crime while ignoring systemic issues and over-policing that created the statistics he loved to quote.

The media continues to present him as a "complicated figure" or "product of his time." No. He was a racist who caused lasting damage to Black communities through policy and propaganda.

It's not about "canceling" the dead - it's about honest history. Stop the whitewashing. Terry Gene was racist. Face it.`
    },
    {
      id: 'weight-loss-drug-effects',
      title: 'Have You READ the Side Effects?',
      summary: 'The dangerous truth about weight loss drugs that Big Pharma doesn\'t want you to know.',
      thumbnail: sideEffectsImage,
      content: `**By BMZ Staff**

Before you inject that "miracle" weight loss drug, have you actually READ the side effects? The pharmaceutical industry is making billions while downplaying serious risks.

**Ozempic/Wegovy Side Effects They Minimize:**
- Gastroparesis (stomach paralysis) - some cases are PERMANENT
- Severe depression and suicidal thoughts
- Pancreatitis that can be fatal
- Kidney failure requiring dialysis
- Thyroid tumors (yes, cancer)
- Vision loss and retinopathy
- Severe malnutrition from inability to eat

**Mounjaro/Zepbound Hidden Dangers:**
- Gallbladder disease requiring surgery
- Severe allergic reactions
- Intestinal blockages
- Hair loss (not just a little - we're talking bald patches)
- Bone density loss
- Heart palpitations and irregular rhythms

**The Financial Side Effect:**
- $1,000-$1,500 per month
- Insurance companies dropping coverage
- Weight returns immediately when stopped
- Creating lifetime dependence on Big Pharma

**What They're Not Telling You:**
- Clinical trials were short-term (most under 2 years)
- Long-term effects completely unknown
- Participants were carefully selected - not representative
- Adverse events are underreported
- FDA fast-tracked approval under pressure

These drugs work by literally making you sick - slowing digestion, causing nausea, making food repulsive. That's not health, that's induced illness.

Meanwhile, they suppress natural alternatives: proper nutrition, exercise, addressing food deserts in Black communities, making healthy food affordable. Why? Because there's no patent on vegetables.

Your body is not broken. The system pushing these drugs is. Read the side effects. Research thoroughly. Your life may depend on it.`
    },
    {
      id: 'media-bias-white-violence',
      title: 'Media Bias: White Male Violence',
      summary: 'They don\'t show their faces - Michigan Walmart stabbing exposes double standard in crime coverage.',
      thumbnail: mediaBiasImage,
      content: `**By BMZ Staff**

Another day, another violent attack by a white male, and another example of media protecting white criminals while demonizing Black victims. Today's Walmart stabbing in Michigan follows the same playbook.

**The Michigan Walmart Attack:**
A white male, 34, stabbed multiple people in a Walmart today. Notice what's missing from every news report? His photo. His name is buried. He's a "troubled individual" with "mental health issues."

**The Media's Protection Pattern:**
- White male shooter = "lone wolf," "mental health crisis," "good kid from good family"
- Black suspect = mugshot plastered everywhere, criminal history exposed, neighborhood blamed

**Recent Examples Media Buried:**
- Nashville mall shooting (white male) - No photo for 72 hours
- Denver office attack (white male) - Called "workplace dispute"
- Portland street rampage (white male) - "Mental health episode"
- Phoenix family killer (white male) - "Tragic domestic situation"

**Meanwhile, When It's a Black Person:**
- Mugshot within hours
- Criminal record from age 12 exposed
- Interview neighbors for negative comments
- Analyze rap lyrics if they exist
- Blame "culture" and single mothers

**The Walmart Stabbing Coverage:**
- No suspect photo after 8 hours
- Focus on his "difficult childhood"
- Interviewing his high school teachers (all positive)
- Already discussing mental health resources
- Victim stories minimized

**Why This Matters:**
This bias shapes public perception. White violence is individualized - "bad apple." Black violence is racialized - "those people." This protects white supremacy by refusing to acknowledge patterns of white male violence.

Statistics they won't report: White males commit 62% of mass shootings, 71% of domestic terrorism, majority of serial killings. But we don't see think pieces about "white male culture" or demands for white leaders to condemn it.

The revolution will not be televised because the media is too busy protecting white male terrorists while criminalizing Black existence.

Wake up. Document everything. Share the truth they hide.`
    },
    {
      id: 'essence-fest-fallout',
      title: 'Essence Fest Fallout',
      summary: 'Major artists pull out after controversy over ticket prices and vendor treatment sparks community outrage.',
      thumbnail: essenceFestImage,
      content: `**By BMZ Staff**

The 2025 Essence Festival faces unprecedented backlash as several headline artists withdraw from the event following revelations about exorbitant vendor fees and limited opportunities for Black-owned businesses to participate.

What started as whispers in the community has erupted into a full-scale controversy. Local Black vendors report being quoted booth fees of $15,000-$25,000 for the weekend festival, effectively pricing out small businesses from the very community the festival claims to celebrate.

"They want us to perform, they want us to attend, but they don't want us to profit," says Keisha Williams, owner of a popular New Orleans boutique who has been trying to secure vendor space for three years. "This festival makes millions off our culture while we struggle to participate."

The controversy deepened when internal documents revealed that non-Black corporate sponsors received preferential placement and reduced fees, while Black-owned businesses faced stringent requirements and inflated costs.

Artists including several Grammy winners have announced their withdrawal from the lineup, citing solidarity with Black business owners. "I can't in good conscience perform at an event that exploits the very community it claims to uplift," one artist stated on social media.

Local activists have called for a boycott of the festival unless organizers address the concerns. They're demanding transparent pricing, reserved spaces for Black vendors at reasonable rates, and representation on the planning committee.

The Essence Festival, which generates an estimated $280 million in economic impact for New Orleans, has yet to respond to the growing criticism. Meanwhile, alternative events organized by and for the Black community are gaining momentum, with several "True Essence" popup festivals planned for the same weekend.

This controversy reflects larger questions about who profits from Black culture and whether flagship events truly serve the communities they represent.`
    },
    {
      id: 'african-hair-shop-boycott',
      title: 'African Hair Shop Boycott',
      summary: 'FBA communities organize nationwide boycott of beauty supply stores amid rising tensions and disrespect.',
      thumbnail: hairShopImage,
      content: `**By BMZ Staff**

A grassroots movement calling for the boycott of non-Black owned beauty supply stores has gained significant traction across major cities, as FBA communities demand respect and economic reciprocity from businesses that profit from Black hair care needs.

The movement, sparked by a viral video showing a customer being followed and harassed in a beauty supply store in Houston, has evolved into a larger conversation about economic exploitation and disrespect in Black communities.

"For decades, we've spent billions in stores where we're treated like criminals, where our daughters are followed and profiled, and where not a single dollar is reinvested in our community," says organizer Tamara Johnson. "Enough is enough."

The boycott has exposed uncomfortable truths about the beauty supply industry. Despite Black women spending an estimated $2.5 billion annually on hair care, less than 3% of beauty supply stores are Black-owned. The overwhelming majority are owned by other groups who have monopolized distribution channels and locked out Black entrepreneurs.

Participants in the boycott report disturbing patterns: being followed by multiple employees, having products snatched from their hands for "inspection," and being refused returns on unopened items while watching other customers receive different treatment.

The movement has sparked action beyond boycotts. Groups in Atlanta, Detroit, and Los Angeles are pooling resources to open Black-owned beauty supply cooperatives. "Buy Black Beauty" directories are emerging to help consumers find Black-owned alternatives.

Some store owners have attempted dialogue, but community leaders remain firm. "Respect is non-negotiable. Either treat us with dignity and partner with our community, or we'll build our own," states Marcus Williams, an economic justice advocate.

The boycott has already shown impact, with several stores reporting 40-60% drops in sales. More importantly, it has reignited conversations about economic self-determination and the importance of controlling the businesses that serve Black communities.

As one participant noted, "This isn't just about hair products. It's about respect, reciprocity, and reclaiming our economic power."`
    },
    {
      id: 'hidden-colors-6',
      title: 'Hidden Colors 6',
      summary: 'New documentary installment reveals suppressed history of Black Wall Streets beyond Tulsa.',
      thumbnail: hiddenColorsImage,
      content: `**By BMZ Staff**

The highly anticipated sixth installment of the Hidden Colors documentary series promises to shed light on the numerous Black Wall Streets that thrived across America before being systematically destroyed, extending far beyond the well-known Tulsa massacre.

Director Tariq Nasheed reveals that Hidden Colors 6 uncovers at least 50 prosperous Black business districts that were decimated through violence, discriminatory policies, and economic warfare. "Tulsa wasn't an isolated incident - it was part of a pattern to destroy Black economic independence," Nasheed states.

The documentary features newly discovered footage and documents from:

**Durham, North Carolina's Black Wall Street** - Home to North Carolina Mutual Life Insurance Company, the largest Black-owned business in the early 1900s, and Mechanics and Farmers Bank. The district faced systematic destruction through "urban renewal" in the 1960s.

**Richmond, Virginia's Jackson Ward** - Known as the "Harlem of the South," this district housed over 100 Black-owned businesses and several banks. Interstate 95 was deliberately routed through its heart, destroying the community.

**Detroit's Black Bottom** - A thriving district with 350 Black-owned businesses, destroyed for freeway construction despite community protests. The film includes interviews with descendants who lost generational wealth overnight.

The documentary also exposes how post-Reconstruction laws specifically targeted Black economic success, including licensing requirements designed to exclude Black professionals and zoning laws that destroyed Black commercial districts.

"What's most powerful is seeing the photographs and film footage of these communities at their peak," says historian Dr. Kendra Fields, featured in the film. "These weren't struggling areas - they were prosperous districts that rivaled any in America."

Hidden Colors 6 connects historical destruction to present-day challenges, showing how the loss of these economic centers created wealth gaps that persist today. It also highlights modern Black Wall Streets emerging in cities like Atlanta and Houston, and the importance of protecting them.

The film includes never-before-seen documents showing government coordination in destroying these districts and testimonies from elderly survivors who witnessed the destruction firsthand.

Early screenings have sparked emotional responses and renewed calls for reparations based on documented economic losses. The film serves not just as history but as a blueprint for rebuilding Black economic power.

"This isn't just about the past," Nasheed emphasizes. "It's about understanding why we must build and protect our own economic institutions today."`
    }
  ];

  const featuredArticle = {
    title: 'WHITE CRIMES MATTER',
    summary: 'The hidden violence in America\'s white-majority towns — and the media\'s choice to look away.',
    image: '/assets/white-crimes-matter-thumbnail.png',
    content: `**By BMZ Staff**

⸻

Editor's Note

This story does not condone or excuse violent crime anywhere. Every victim matters. Our aim is to expose a long-running bias in U.S. crime coverage: violence in Black neighborhoods is amplified, while equally serious crime in majority-white places is often invisible.

⸻

A Story Half Told

Every night in America, the same images flicker across television screens: flashing sirens, yellow police tape, the face of a young Black man in a mugshot. The narrative is so routine it barely registers. Crime is shown as something that happens "over there," in "those neighborhoods," almost always coded as Black or brown.

But here's the truth the cameras leave behind: many of the highest violent-crime rates in America occur in communities that are majority white. Their stories are quieter, their tragedies less visible, and their victims — equally human, equally grieving — often erased from the national conversation.

Why? Because when the media chooses its crime stories, it doesn't just report the news — it shapes the nation's imagination. And in that imagination, crime has been painted with one color far too often.

⸻

The Numbers the Media Ignores

Violent crime in the U.S. has been falling. According to the FBI, violent crime declined by about 3% in 2023 compared to 2022, and then fell another 4.5% in 2024. The national violent-crime rate in 2023 was 364 per 100,000 residents.

And yet, across the country, majority-white states and cities consistently reported higher-than-average rates:

• **Alaska (statewide):** 726 per 100k  
• **Tennessee (statewide):** ~628 per 100k  
• **Arkansas (statewide):** ~620 per 100k  
• **Missouri (statewide):** 459 per 100k  
• **Montana (statewide):** 442 per 100k  
• **Springfield, MO (city):** 1,178 per 100k  
• **Billings, MT (city):** ~929 per 100k  
• **Rockford, IL (city):** ~1,148 per 100k  
• **Davenport, IA (city):** ~691 per 100k  
• **Rapid City, SD (city):** ~742 per 100k  

Each of these jurisdictions is majority-white according to U.S. Census QuickFacts and DataUSA. Some, like Montana, are over 85% non-Hispanic white. Yet how many of these places appear regularly in national conversations about crime?

⸻

The Missing Faces of Grief

Behind every statistic lies a human story.

In Springfield, Missouri, families attend funerals at rates nearly triple the national average. In Billings, Montana, a city of just over 100,000, violent assaults have left residents shaken and neighborhoods scarred. In Rapid City, South Dakota, community leaders are pleading for more resources as violence strains a city where more than three-quarters of the population is white.

These are not isolated tragedies. They are part of a broader pattern — and yet, they rarely reach the national spotlight. When crime is framed almost exclusively through Black victims and Black suspects, the grief of white-majority communities is left in the shadows, unacknowledged, untreated, unseen.

And grief that is unseen festers.

⸻

How Bias Gets Built

Studies show that local television news and national networks consistently overrepresent Black suspects in crime coverage relative to actual arrest data. This skew reinforces stereotypes, shapes public fears, and primes policy debates around race rather than reality.

When crime in white-majority areas is underreported, two things happen:

1. **Black communities are stigmatized.** They become the face of violence even when they are not statistically unique.
2. **White victims are silenced.** Their stories matter less in the national imagination, depriving them of the empathy and resources that visibility brings.

This is not just a journalistic failing — it's a moral one.

⸻

Why It Matters

America cannot afford half-truths. Public policy, community resources, and even democracy itself depend on trust. If people are only ever shown certain faces of crime, they are being misled about reality. That distortion fuels division, breeds resentment, and keeps us from addressing the real root causes of violence: poverty, addiction, inadequate mental health care, underfunded schools, and unequal policing.

By reporting crime unevenly, the media does more than get the story wrong. It reinforces the very divides that make violence more likely.

⸻

Toward a Fuller Truth

This investigation is not about denying crime in Black neighborhoods, nor excusing violence in white-majority towns. It is about demanding honesty. Every victim matters. Every community deserves visibility. And every American deserves news that shows the whole map, not just the half that fits an old stereotype.

White Crimes Matter is not a slogan — it is a demand for fairness in journalism. Because until we tell the full story, we will never find the full solution.

⸻

Sources & Citations

1. FBI, Crime in the Nation, 2023–2024 Releases — violent crime trends.
2. USAFacts, Alaska Crime Data Dashboard — 2023 violent-crime rate.
3. USAFacts, Tennessee & Arkansas State Crime Data Dashboards.
4. USAFacts, Missouri Crime Data Dashboard.
5. USAFacts & CSG Justice Center, Montana Crime Snapshot.
6. Show-Me Institute citing FBI CDE, Springfield, MO 2023 violent crime rate (1,178). Springfield Police Department, 2023 Annual Report.
7. Billings Police Department, 2023 Annual Report. FBI-derived city rate via BeautifyData.
8. Rockford Police Department press release (2023) + FBI-derived city rate.
9. City of Davenport, Gun Violence Reduction Updates 2023. FBI-derived city rate.
10. Rapid City Police Department, 2023 Violent Crime Statistics. FBI-derived city rate.
11. U.S. Census Bureau QuickFacts & DataUSA (Alaska, Tennessee, Arkansas, Missouri, Montana, Springfield, Billings, Rockford, Davenport, Rapid City).
12. Dixon, T.L. & Linz, D. (2000). Overrepresentation and Underrepresentation of Black Americans and Latinos as Lawbreakers on Television News. Journal of Communication.`
  };

  return (
    <>
      <Helmet>
        <title>Black Media Zone (BMZ) - News & Stories | BlackBook</title>
        <meta name="description" content="Black Media Zone (BMZ) - Stay informed with news, stories, and perspectives from the Black community. Real stories. Real voices. Real impact." />
        
        <meta property="og:title" content="Black Media Zone (BMZ) | BlackBook" />
        <meta property="og:description" content="News, stories, and perspectives from the Black community. Real stories. Real voices." />
        <meta property="og:image" content="https://www.blackbook.family/logo.jpeg" />
        <meta property="og:url" content="https://www.blackbook.family/bmz" />
        <meta property="og:type" content="website" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Black Media Zone (BMZ)" />
        <meta name="twitter:description" content="News and stories from the Black community" />
        <meta name="twitter:image" content="https://www.blackbook.family/logo.jpeg" />
      </Helmet>
      <style dangerouslySetInnerHTML={{ __html: bmzStyles }} />
      <div className="bmz-container">
        {selectedArticle ? (
          // Article Detail View
          <>
            <button 
              onClick={() => setSelectedArticle(null)}
              className="bmz-back-button"
            >
              ← Back to BMZ
            </button>
            
            {(() => {
              const article = selectedArticle === 'featured' 
                ? featuredArticle 
                : articles.find(a => a.id === selectedArticle);
              
              if (!article) return null;
              
              return (
                <div className="bmz-article-content">
                  {selectedArticle === 'featured' && (
                    <img 
                      src={featuredArticle.image} 
                      alt="Hurricane Katrina 20th Anniversary"
                    />
                  )}
                  
                  <h1>{article.title}</h1>
                  <p><em>{article.summary}</em></p>
                  {article.content.split('\n').map((line, index) => {
                    // Handle markdown images
                    if (line.trim().startsWith('![') && line.includes('](')) {
                      const imageRegex = /!\[([^\]]*)\]\(([^)]+)\)/;
                      const match = line.match(imageRegex);
                      
                      if (match) {
                        return (
                          <div key={index} className="bmz-article-image-container" style={{ margin: '1.5rem 0', textAlign: 'center' }}>
                            <img 
                              src={match[2]} 
                              alt={match[1]} 
                              style={{ 
                                maxWidth: '50%', 
                                height: 'auto',
                                borderRadius: '8px',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                display: 'block',
                                margin: '0 auto'
                              }}
                            />
                            {match[1] && (
                              <p style={{ 
                                fontSize: '0.9rem', 
                                color: '#666', 
                                fontStyle: 'italic', 
                                marginTop: '0.5rem' 
                              }}>
                                {match[1]}
                              </p>
                            )}
                          </div>
                        );
                      }
                    }
                    
                    // Skip empty lines
                    if (!line.trim()) {
                      return <br key={index} />;
                    }
                    
                    // Handle regular paragraphs and bold text
                    const formattedText = line
                      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
                      .replace(/\*([^*]+)\*/g, '<em>$1</em>');
                    
                    return (
                      <p 
                        key={index} 
                        dangerouslySetInnerHTML={{ __html: formattedText }}
                        style={{ lineHeight: '1.6', marginBottom: '1rem' }}
                      />
                    );
                  })}
                </div>
              );
            })()}
          </>
        ) : (
          // BMZ Overview
          <>
            {/* Header */}
            <header className="bmz-header">
              <img 
                src={bmzLogo} 
                alt="BMZ Logo" 
                className="bmz-logo"
              />
            </header>

            {/* Main Content */}
            <div className="bmz-main-container">
              
              {/* Hero Section - BREAKING NEWS */}
              <section className="bmz-hero-section">
                <div 
                  onClick={() => setSelectedArticle('featured')}
                  className="bmz-thumbnail-story"
                >
                  <img 
                    src={featuredArticle.image}
                    alt={featuredArticle.title}
                    className="bmz-thumbnail-image"
                  />
                  <div className="bmz-thumbnail-content">
                    <h1 className="bmz-thumbnail-title">{featuredArticle.title}</h1>
                    <p className="bmz-thumbnail-summary">{featuredArticle.summary}</p>
                    <button className="bmz-read-more">Read Full Article →</button>
                  </div>
                </div>
              </section>

              {/* Beauty of the Week Section */}
              <section className="bmz-beauty-section">
                <h2 className="bmz-beauty-title">BlackBook Beauty of the Week</h2>
                <img 
                  src={beautyOfTheWeekImage} 
                  alt="BlackBook Beauty of the Week" 
                  className="bmz-beauty-image" 
                />
                <p className="bmz-beauty-prompt">
                  ✨ YOUR TIME TO SHINE ✨<br/>
                  <strong>Be Our Next Beauty Queen!</strong><br/>
                  <em>Apply Now - Limited Spots!</em>
                </p>
                {!showBeautyForm ? (
                  <button 
                    className="bmz-beauty-button"
                    onClick={() => setShowBeautyForm(true)}
                  >
                    Apply Now
                  </button>
                ) : (
                  <div className="mt-6">
                    <BeautyOfWeekForm />
                    <button 
                      className="bmz-beauty-button mt-4"
                      style={{ background: '#666' }}
                      onClick={() => setShowBeautyForm(false)}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </section>
              

              {/* Black Book Ad */}
              <section className="bmz-ad-section bmz-blackbook-ad">
                <div className="bmz-ad-content">
                  <h3>Find Black-Owned Businesses Near You</h3>
                  <p>Discover, support, and connect with authentic Black-owned businesses in your community</p>
                  <button className="bmz-ad-button">Explore Black Book Directory</button>
                </div>
              </section>

              {/* Stories Grid - First Set */}
              <section className="bmz-stories-grid">
                {articles.slice(0, 4).map((article) => (
                  <div 
                    key={article.id}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSelectedArticle(article.id);
                    }}
                    className="bmz-story-card"
                  >
                    <img 
                      src={article.thumbnail}
                      alt={article.title}
                      className="bmz-story-image"
                    />
                    <div className="bmz-story-content">
                      <h3 className="bmz-story-title">{article.title}</h3>
                      <p className="bmz-story-summary">{article.summary}</p>
                    </div>
                  </div>
                ))}
              </section>

              {/* BMZ Subscription Ad */}
              <section className="bmz-ad-section bmz-subscription-ad">
                <div className="bmz-ad-content">
                  <h3>Stay Updated with BMZ</h3>
                  <p>Get the latest news and perspectives that mainstream media won't tell you</p>
                  <button className="bmz-ad-button">Subscribe to BMZ Updates</button>
                </div>
              </section>


              {/* More Stories Grid */}
              <section className="bmz-stories-grid">
                {articles.slice(4).map((article) => (
                  <div 
                    key={article.id}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSelectedArticle(article.id);
                    }}
                    className="bmz-story-card"
                  >
                    <img 
                      src={article.thumbnail}
                      alt={article.title}
                      className="bmz-story-image"
                    />
                    <div className="bmz-story-content">
                      <h3 className="bmz-story-title">{article.title}</h3>
                      <p className="bmz-story-summary">{article.summary}</p>
                    </div>
                  </div>
                ))}
              </section>

              {/* Black Book Business Ad */}
              <section className="bmz-ad-section bmz-business-ad">
                <div className="bmz-ad-content">
                  <h3>List Your Business on Black Book</h3>
                  <p>Join thousands of Black-owned businesses reaching customers who want to support you</p>
                  <button className="bmz-ad-button">Add Your Business</button>
                </div>
              </section>

            </div>
          </>
        )}
      </div>
    </>
  );
};

// BMZ Main Component with routing
const BMZPage = () => {
  const [match, params] = useRoute('/bmz/story/:slug');
  
  if (match && params) {
    return <StoryPage slug={params.slug} />;
  }
  
  return <BMZHomePage />;
};

export default BMZPage;